import React, { useContext } from 'react'
import SurveysGuide from './SurveyGuide'
import SurveysSummaryBoxes from './SurveySummaryBoxes'
import { ManageSurveyContext } from '../ManageSurveyContext'

const SurveysSummaryDraft = () => {
  const { survey } = useContext(ManageSurveyContext)

  return (
    <div className="Summary">
      <SurveysGuide />
      <SurveysSummaryBoxes
        questions={survey.questions.length}
        recipients={0}
        responses={0}
      />
    </div>
  )
}

export default SurveysSummaryDraft
